import { render } from "./PageThreadShow.vue?vue&type=template&id=ec273b28&scoped=true"
import script from "./PageThreadShow.vue?vue&type=script&lang=js"
export * from "./PageThreadShow.vue?vue&type=script&lang=js"

import "./PageThreadShow.vue?vue&type=style&index=0&id=ec273b28&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec273b28"]])

export default __exports__